<template>
    <div>
        <div class="flex justify-between">
            <div class="w-3/4">
                <div>
                    <div class="grid grid-cols-4 gap-y-6 gap-x-4">
                        <div class="flex flex-col">
                            <label for="country_id">
                                Country / Region
                            </label>
                            <select
                                name="country_id"
                                class="mt-1 form-select block w-full text-xl"
                                v-model="building.country_id"
                            >
                                <option value=""></option>
                                <option
                                    v-for="country in countries" :key="country.id"
                                    :value="country.id"
                                >
                                    {{ country.name }}
                                </option>
                            </select>
                        </div>

                        <div class="flex flex-col">
                            <label for="building_number">
                                Building #
                            </label>
                            <input
                                name="building_number"
                                class="mt-1 form-input block w-full text-xl"
                                v-model="building.building_number"
                            >
                        </div>

                        <div class="col-span-2 flex flex-col">
                            <label for="building_name">
                                Building Name
                            </label>
                            <input
                                name="building_name"
                                class="mt-1 form-input block w-full text-xl"
                                v-model="building.building_name"
                            >
                        </div>

                        <div class="col-span-2 flex flex-col">
                            <label for="address_line_1">
                                Address Line 1
                            </label>
                            <input
                                name="address_line_1"
                                class="mt-1 form-input block w-full text-2xl"
                                v-model="building.address_line_1"
                            >
                        </div>

                        <div class="col-span-2 flex flex-col">
                            <label for="address_line_2">
                                Address Line 2
                            </label>
                            <input
                                name="address_line_2"
                                class="mt-1 form-input block w-full text-2xl"
                                v-model="building.address_line_2"
                            >
                        </div>

                        <div class="flex flex-col col-span-2">
                            <label for="city">
                                City
                            </label>
                            <input
                                name="city"
                                class="mt-1 form-input block w-full text-xl"
                                v-model="building.city"
                            >
                        </div>

                        <div v-if="building.country_id == 16" class="col-span-1 flex flex-col">
                            <label for="state">
                                State
                            </label>
                            <select
                                name="state"
                                class="mt-1 form-select text-xl w-full max-w-fit"
                                v-model="building.state"
                            >
                                <option value=""></option>
                                <option
                                    v-for="(state, stateIndex) in states" :key="stateIndex"
                                    :value="state.state"
                                >
                                    {{ state.state }}
                                </option>
                            </select>
                        </div>

                        <div class="col-span-1 flex flex-col">
                            <label for="zip_code">
                                ZIP / Postal
                            </label>
                            <input
                                name="postal_code"
                                class="mt-1 form-input block w-full text-xl"
                                v-model="building.postal_code"
                            >
                        </div>

                        <div v-if="building.country_id == 16" class="col-span-2 flex flex-col">
                            <label for="county">County Name</label>
                            <input
                                type="text"
                                name="county"
                                class="mt-1 form-input text-xl"
                                v-model="building.county"
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="ml-16 w-1/4">
                <h3 class="module-header text-center">Geolocation</h3>
                <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4">
                    <div v-if="regions.length" class="flex flex-col">
                        <label for="region_id">
                            Region
                        </label>
                        <select
                            name="region_id"
                            class="mt-1 form-select block w-full text-xl"
                            v-model="building.region_id"
                        >
                            <option value=""></option>
                            <option
                                v-for="region in regions" :key="region.id"
                                :value="region.id"
                            >
                                {{ region.name }}
                            </option>
                        </select>
                    </div>

                    <div class="flex flex-col">
                        <label for="latitude">
                            Latitude
                        </label>
                        <input
                            name="latitude"
                            class="mt-1 form-input block w-full text-2xl"
                            v-model="building.latitude"
                        >
                    </div>

                    <div class="flex flex-col">
                        <label for="longitude">
                            Longitude
                        </label>
                        <input
                            name="longitude"
                            class="mt-1 form-input block w-full text-2xl"
                            v-model="building.longitude"
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            buildingData: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                building: this.buildingData,

                states: {},
                countries: {},
                availableRegions: {},
            }
        },

        mounted() {
            this.initAddressInfo();
        },

        computed: {
            regions() {
                return _.filter(this.availableRegions, ['country_id', this.building.country_id]);
            }
        },

        methods: {
            initAddressInfo() {
                axios.get('/api/address-info').then((response) => {
                    this.states = response.data.states;
                    this.countries = response.data.countries;
                    this.availableRegions = response.data.regions;
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>